export default "__VITE_ASSET__Cqry9xZG__"